import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AnimatedModalComponent } from '@app/shared/modals/animated-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as amplitude from 'amplitude-js';
import { DepositPromotionInterface } from '@app/_v2/template/modals/deposit/deposit-bonus.component';
import { BonusService } from '@app/core/bonus.service';
import { AlertService } from '@app/core/alert.service';

@Component({
  selector: 'app-deposit-promotion-modal',
  template: `
    <ng-container *ngIf="item">
      <div (click)="reject()" class="icon close-popup"><i class="fal fa-times"></i></div>
      <div class="label yellow-label">welcome package promotion</div>
      <div class="_10px-spacer"></div>
      <h3>{{ item.name }}</h3>
      <img src="/assets/images/v2/withdraw-disabled.svg" height="200" />
      <p>{{ item.description }}</p>
      <app-form-button class="primary full-width" [loading]="loading" [disabled]="loading" (click)="activate()"
        >Activate bonus</app-form-button
      >
      <br />
      <app-form-button class="secondary full-width" (click)="reject()">Skip</app-form-button>
      <br />
      <a href="/legal/bonus-terms" (click)="showTerms($event)">Bonus terms & conditions</a>
    </ng-container>
  `,
  styles: [
    `
      :host {
        text-align: center;
        align-items: center;
        display: flex;
        flex-direction: column;
      }
      h3 {
        margin-bottom: 0;
      }
    `,
  ],
})
export class DepositPromotionModalComponent extends AnimatedModalComponent implements OnInit {
  _items: Array<DepositPromotionInterface> = [];
  item: DepositPromotionInterface;
  loading = false;

  constructor(
    private ref: NgbActiveModal,
    protected elRef: ElementRef,
    protected renderer: Renderer2,
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    protected http: HttpClient,
    protected bonusService: BonusService,
    protected alertService: AlertService
  ) {
    super(elRef, renderer);
  }

  ngOnInit() {
    amplitude.getInstance().logEvent('Deposit - Promotion Modal');
    this.item = this._items[0];
  }

  public close(): void {
    this.ref.close(0);
  }

  public reject(): void {
    this.ref.dismiss(1);
  }

  public showTerms($event: Event): void {
    $event.preventDefault();
    this.router.navigate(['/legal/bonus-terms', { outlets: { modal: null } }]).then(() => {
      this.router.navigate(['/', { outlets: { modal: null } }]).then(() => {
        this.reject();
      });
    });
  }

  public activate(): void {
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.bonusService
      .activateBonus(this.item._id)
      .then(() => {
        this.loading = false;
        this.close();
      })
      .catch(e => {
        this.loading = false;
        this.alertService.error({ title: 'Error!', text: e.json().error });
      });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/deposit-promotion-modal.component.ts